<template>
	<div>
		<CubePage type="myorder-view" :title="title==2?'浏览过的小店':'我的收藏'" :backurl="'/my'">
			<div slot="content" class="content">
				<van-search placeholder="请输入小店名称" v-model="re_value" @search="onSearch" show-action>
					<div slot="action" @click="onSearch">
						<van-button type="primary">搜索</van-button>
					</div>
				</van-search>
				<div style="margin-top: 10px;">
					<van-empty v-if="isNoData" class="custom-image"
						image="https://img01.yzcdn.cn/vant/custom-empty-image.png" description="您还没有浏览过店铺" />
					<van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
						:immediate-check="false">
						<div class="list-box">
							<div class="list-item" v-for="(item,index) in list" :key="index">
								<div class="item-card">
									<van-image class="card-img" round :src="item.avatar" />
									<div class="card-content ells">
										<div class="conten-title">
											<p class="t ells">{{item.storename}}</p>
										</div>
										<div class="conten-desc">
											<p>
												<van-icon name="clock-o" style="padding-right: 10px;" />{{item.time}}
											</p>

										</div>
									</div>
									<div>
										<van-button @click="goShop(item.id)" type="warning" round size="mini">前往店铺
										</van-button>
									</div>
								</div>
							</div>
						</div>
					</van-list>
				</div>

			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				list: [],
				re_value: '',
				loading: false,
				finished: false,
				isNoData: false,
				pageIndex: 1,
				pageTotal: 0,
				title: this.$route.query.n
			}
		},
		created() {
			this.getData()
		},
		methods: {
			onLoad() {
				// 异步更新数据
				// setTimeout 仅做示例，真实场景中一般为 ajax 请求
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.getData();
				}, 1000)
			},
			onSearch() {
        this.list= [];
        this.pageIndex=1;
        this.pageTotal=0;
        this.getData();
			},
			goShop(id) {
				/******leo跳转********/
				util.redirect('shop?store_id=' + id + '&isBack=true')
				/******leo跳转********/
				/*this.$router.push({
					path: 'shop',
					query: {
						store_id: id,
						isBack: 'true'
					}
				})*/
			},
			getData() {
				let that = this;
				var url = "/addons/litestore/api.account/myBrowse"
				// 1:收藏 2:浏览
				let param = {
					page: that.pageIndex,
					type: that.title,
					search: that.re_value
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						let data = result.data

						//leo
						if (param.type == 2 && data.total < 1) {

							if (result.code == 1) {
								console.log('1111', result.data.path)
                if (data.path){
                  util.redirect(result.data.path);
                }
							}

						}

						that.loading = false;
            that.finished = false;
						//这里对状态 进行分类
						that.pageTotal = data.total
						if (that.pageTotal < 1) {
							that.isNoData = true
						}
						if (data.list == null || data.list.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.list = that.list.concat(data.list);

            console.log(that.pageTotal)
            console.log(that.list.length)
						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.list.length >= that.pageTotal) {
							that.finished = true;
						}
					},
				);
			}
		}
	}
</script>
<style lang="less">
	@import url("../../../assets/css/order.css");
	@import url("../../../assets/css/listboxless.less");
</style>
<style lang="less" scoped="scoped">
	.van-search {
		.van-search__action {
			line-height: 0;
		}

		.van-button {
			height: 34px;
		}
	}

	.list-box {
		.list-item {
			margin-bottom: 10px;
			background-color: #FFFFFF;

			.item-card {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 20px 15px;
				box-sizing: border-box;

				.card-img {
					width: 60px;
					height: 60px;
				}

				.v {
					width: 40px;
				}

				.card-content {
					flex: 1;
					flex-shrink: 0;
					margin: 0 15px;

					.red-text {
						color: #d40000;
					}

					.conten-title {
						display: flex;
						justify-content: space-between;

						.t {
							max-width: 140px;
							font-size: 16px;
							font-weight: 600;
						}

						.r {
							font-size: 14px;
						}
					}

					.conten-desc {
						padding-top: 8px;
						display: flex;
						justify-content: space-between;
						align-items: center;

						p {
							color: #a3a3a3;
							font-size: 14px;
						}
					}
				}
			}

			.item-btns {
				height: 50px;
				display: flex;
				justify-content: space-around;
				align-items: center;

				.btn-item {

					.van-icon,
					.iconfont {
						vertical-align: middle;
						font-size: 20px;
					}

					.btn-text {
						font-size: 14px;
						padding: 0 5px;
					}
				}
			}
		}
	}
</style>
